import notesActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import { combineReducers } from 'redux';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';

// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
const emptyArray = [];

const INITIAL_NOTES_CACHE_STATE = {
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  notesCache: emptyArray,
  notesCacheInitialized: false,
  isSearching: false,
};

export const reducers = {
  get: createAsyncRequestReducer(notesActionTypes.FETCH_NOTES),
  create: createAsyncRequestReducer(notesActionTypes.CREATE_NOTE),
  update: createAsyncRequestReducer(notesActionTypes.UPDATE_NOTE),
  delete: createAsyncRequestReducer(notesActionTypes.DELETE_NOTE),
  search: createAsyncRequestReducer(notesActionTypes.SEARCH_NOTES),
  notesCache: createReducer(INITIAL_NOTES_CACHE_STATE, {
    [notesActionTypes.SET_NOTES_CACHE]: (state: any, action: any) => ({
      ...state,
      notesCache: action.cache,
    }),
    [notesActionTypes.SET_NOTES_CACHE_INITIALIZED]: (
      state: any,
      action: any,
    ) => ({
      ...state,
      notesCacheInitialized: action.initialized,
    }),
    [notesActionTypes.SET_NOTES_IS_SEARCHING]: (state: any, action: any) => ({
      ...state,
      isSearching: action.isSearching,
    }),
    [notesActionTypes.RESET_SET_NOTES_STATE]: () => INITIAL_NOTES_CACHE_STATE,
  }),
};

export default combineReducers(reducers);
